"use strict";

var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericCSSPropertyValidator = void 0;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var GenericCSSPropertyValidator = /*#__PURE__*/function () {
  function GenericCSSPropertyValidator(_ref, isShorthand) {
    var model = _ref.model,
      config = _ref.config,
      propertyName = _ref.propertyName;
    _classCallCheck(this, GenericCSSPropertyValidator);
    _defineProperty(this, "model", void 0);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "compatCategory", void 0);
    _defineProperty(this, "propagationCategory", void 0);
    _defineProperty(this, "displayCategory", void 0);
    _defineProperty(this, "propertyName", void 0);
    _defineProperty(this, "_isShorthand", void 0);
    this.model = model;
    this.config = config;
    this.compatCategory = model.translatable ? 'native' : 'web';
    this.propagationCategory = model.inheritable ? 'flow' : 'retain';
    this.displayCategory = model.display;
    this.propertyName = propertyName;
    this._isShorthand = isShorthand;
  }
  /**
   * Normalize value from inline styles
   *
   * @param value
   */
  _createClass(GenericCSSPropertyValidator, [{
    key: "isShorthand",
    value: function isShorthand() {
      return this._isShorthand;
    }
  }]);
  return GenericCSSPropertyValidator;
}();
exports.GenericCSSPropertyValidator = GenericCSSPropertyValidator;